// extracted by css-extract-rspack-plugin
export default {"titleInputWrapper":"IssueTitleInput-module__titleInputWrapper__sqy0l"};